<div class="row mt-2">
    <div class="col-lg-2 col-2 col-md-2"></div>
    <div class="col-lg-8 col-8 col-md-8">
        <div class="card" style="margin-left: 10px!important;margin-right: 10px!important;">
            <div class="card-header bg-light pt-3 pb-3">
                <p class="d-md-inline-block fs--1 mt-3 ml-5" style="font-weight:800;font-size:24px!important;">
                    iCeipts Privacy Policy
                </p>
            </div>
            <div class="progress" style="height: 2px">
                <div class="progress-bar" role="progressbar" aria-valuenow="33" aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>iCeipts is committed to protecting your privacy and this privacy statement describes in
                            greater detail the privacy practices of iCeipts Technologies </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">General</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>Review these Terms of Service ("Agreement") thoroughly.
                            This Agreement is a legal agreement between the User and iCeipts.
                            By accepting electronically (for example, clicking “I Agree”), installing, accessing or using the
                            Services, User agrees to these terms.
                            If the User does not agree to this Agreement, then he/she may not use the Services. This License
                            Agreement shall be governed by and construed in accordance with the laws of the INDIA.</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Modification of terms & conditions</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>These terms may be updated from time to time in the future.
                            The User should agree to review our Terms and Conditions regularly by visiting this page.
                            Continued access to or use of the service will mean that the User agrees to the change.</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">When This Privacy Statement Applies</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>Its liability to the User is limited to those who have downloaded the iCeipts
                            application by clicking on the “I Agree/Login” button for Terms and Conditions.</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Description of Services</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>We provide an array of services including Inventory management, Invoicing, Reporting tool,
                            Estimate/Order Form creator and so on to serve as a complete business management software ("Service"
                            or "Services"). The User may use the Services for his/her personal and business use or for internal
                            business purpose in the organization that he/she represent. The User may download the application
                            from the Official website/ Google Play Store using the Internet. Once downloaded, the User no longer
                            needs an internet connection for its usage. A User can create and add content to his/her account
                            staying offline.
                            But, the User is responsible for obtaining access to the Internet and the device necessary to use
                            the Services. ( Side Note: iCeipts tries its best to make Businesses compliant to
                            taxation and other laws as much as possible.
                            But, it is solely the User’s responsibility to see that he/she remains compliant with GST and other
                            laws levied by Government. iCeipts is not in any case responsible for the violation of
                            the compliance caused by software)</p>
                    </div>
                </div>
        
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Business Data and Privacy</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>The User alone is responsible for maintaining the confidentiality of his/her username, password and
                            other sensitive information.
                            He/She is responsible for all activities that occur in his/her user account and he/she agrees to
                            inform us immediately of any unauthorized use of their user account by email to admin@iceipts.com.
                            in or by calling us on any of the numbers listed on http://vyaparapp.in/#contact.
                            We are not responsible for any loss or damage to his/her or to any third party incurred as a result
                            of any unauthorized access and/or use of his/her user account, or otherwise.
                            We are neither responsible for any kind of data loss as performing necessary backups on data is
                            solely the User’s responsibility.
                            iCeipts is not responsible for any kind of data discrepancy or any type of loss occured
                            due to data discrepancy/software issue.</p>
                    </div>
                </div>
        
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Data Ownership</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>The User owns the content created or stored by his/her as we respect his/her right to ownership of
                            content created or stored by them.
                            The Users use of the Services does grant iCeipts  the license to use, reproduce, adapt,
                            modify, publish or distribute the content created by them or stored in the user’s account for
                            iCeipts internal purpose.
                            iCeipts tries keeping Users data safe but holds zero responsibility in case of data
                            leaks</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Permissions</p>
                        <hr>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Camera:</p>
                        </div>
                        <div class="col-10">
                            <p>To take the picture of the bills etc to be attached with transactions.</p>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Contacts:</p>
                        </div>
                        <div class="col-10">
                            <p> This app collects contact information like number of contacts on the device with a contact number
                                and without a contact number. In addition to it, the app collects other non-personal information
                                to understand the risk profile of the user and enable credit facility.
                                This app doesn't upload your contacts information like names,contact numbers, emails addresses
                                and other personal information to our servers.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Storage:</p>
                        </div>
                        <div class="col-10">
                            <p>This app collects metadata of files on your device like file names, types, created times, last
                                updated times for credit profile enrichment.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Location:</p>
                        </div>
                        <div class="col-10">
                            <p>This app collects location details to verify your location & current address, to ensure
                                serviceability and to identify unusual activity to prevent against any fraud, we do not collect
                                location when app is in background.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">SMS:</p>
                        </div>
                        <div class="col-10">
                            <p> This app collects SMS data like sender names, SMS body, received time to understand your income,
                                spending patterns and automatically fetch your expenses, bills, credits. We do not read any
                                personal or OTP messages. This data will be shared with Finbox at
                                https://riskmanager.apis.finbox.in</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Device and Personal
                                info:</p>
                        </div>
                        <div class="col-10">
                            <p> This app collects and monitor specific information about users' contact Number and your device
                                including your hardware model, masked contact numbers, operating system and version, unique device
                                identifiers like IMEI and serial number, user profile information to uniquely identify the
                                devices and ensure that unauthorized devices are not able to act on your behalf to prevent
                                frauds.
                                This data will be shared with Finbox at https://riskmanager.apis.finbox.in</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Accounts:</p>
                        </div>
                        <div class="col-10">
                            <p> This app collects and monitor list of account information like account names, account types in
                                your device for credit profile enrichment.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Apps:</p>
                        </div>
                        <div class="col-10">
                            <p>This app collects details of your installed applications to understand your profile. This helps
                                us give quicker approvals and higher credit limits.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Call logs:</p>
                        </div>
                        <div class="col-10">
                            <p>This app uses call logs permission to validate your contact number using missed call. In addition
                                to it, details of your aggregated call information is collected to understand your profile. This
                                helps us give quicker approvals and higher credit limits.
                                We do not read the contact numbers or any personal information.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <p style="font-weight:800;font-size:16px!important; color: rgb(71, 157, 168);">Calendar:</p>
                        </div>
                        <div class="col-10">
                            <p> This app collects event data on your calendar for credit profile enrichment.</p>
                        </div>
                    </div>
        
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Permissions Usage:</p>
                        <hr style="border-bottom: 3px solid #ccc!important;">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of contact</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>This is how we will use your contact permissions:</p>
                        <p>(i) We allow users to sync their contacts from contact to desktop, the contact permissions will be
                            used to facilitate this.</p>
                        <p>(ii) We will show parties that are already iCeipts  users, to show you your potential
                            buyers and suppliers.</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of SMS information</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>We will use SMS data like sender names, SMS body, received time to understand your income, spending
                            patterns and automatically fetch your expenses, bills, credits. We do not read any personal or OTP
                            messages.</p>
                        <p>We collect and monitor SMS sent by 6-digit alphanumeric senders from your inbox to understand your
                            income, spending patterns and automatically fetch your expenses, bills, credits.
                            We collect your historical SMS data as well, as this process will enable you to take financial
                            facilities like loans, credit cards from the regulated financial entities available on the platform.
                            We do not read any personal or OTP messages.
                            This data will be shared with Finbox at https://riskmanager.apis.finbox.in</p>
        
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of device location, device information
                            and personal information</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            We collect and monitor the information about the location of your device to provide serviceability
                            of your loan application, to reduce the risk associated with your loan application and to provide
                            pre-approved customised loan offers.
                            This also helps us to verify the address, make a better credit risk decision and expedite the know
                            your customer (KYC) process.
                            Information the App collects, and its usage depends on how you manage your privacy controls on your
                            device.
                            When you install the App, we store the information we collect with unique identifiers tied to the
                            device you are using.
                            We collect information from the device when you download and install the App and explicitly seek
                            permissions from You to get the required information from the device.
                        </p>
                        <p>
                            The information we collect from your device includes the users' contact number, masked contact numbers,
                            hardware model, build model, RAM, storage; unique device identifiers like IMEI, serial number,
                            SSAID; SIM information that includes network operator, roaming state, MNC and MCC codes, WIFI
                            information that includes MAC address and contact network information to uniquely identify the
                            devices and ensure that no unauthorized device acts on your behalf to prevent frauds.
                            This data will be shared with Finbox at https://riskmanager.apis.finbox.in
                        </p>
        
        
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of installed applications</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            We collect a list of the installed applications’ metadata information which includes the application
                            name, package name, installed time, updated time, version name and version code of each installed
                            application on your device to assess your creditworthiness and enrich your profile with pre-approved
                            customized loan offers.
                        </p>
        
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of Images</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            The images uploaded by users in iCeipts App are stored on our servers so they can be
                            accessed from multiple devices. We do this to enhance your user experience and make it seamless.
                        </p>
        
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Storage</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            We require storage permission so that your KYC and other relevant documents can be securely
                            downloaded and saved on your contact. You can then easily upload the correct KYC related documents for
                            faster loan application details filling and disbursal process. This ensures that you are provided
                            with a seamless experience while using the application.
                        </p>
        
                    </div>
                </div>
        
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Camera</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            We require the camera information permission to provide you with an easy/smooth experience and to
                            enable you to click photos of your KYC documents along with other requisite documents and upload the
                            same on the App during your loan application journey.
                        </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Collection of other non-personal information</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>
                            We automatically track certain information about you based upon your behaviour on our Platform.
                            We use this information to do internal research on our users’ demographics, interests, and behaviour
                            to better understand, protect and serve our users and improve our services.
                            This information is compiled and analysed on an aggregated basis.
                            We also collect your Internet Protocol (IP) address and the URL used by you to connect your computer
                            to the internet, etc.
                            This information may include the URL that you just came from (whether this URL is on our Website or
                            not), which URL you next go to (whether this URL is on our Website or not), your computer browser
                            information, and your IP address.
                        </p>
                        <p>
                            Cookies are small data files that a Website stores on Your computer.
                            We will use cookies on our Website similar to other lending websites/apps and online marketplace
                            websites/apps.
                            Use of this information helps Us identify You in order to make our Website more user friendly.
                            Most browsers will permit You to decline cookies but if You choose to do this it might affect
                            service on some parts of Our Website. If you choose to make a purchase through the Platform, we
                            collect information about your buying behaviour.
                            We retain this information as necessary to resolve disputes, provide customer support and
                            troubleshoot problems as permitted by law.
        
                        </p>
                        <p>
                            If you send us personal correspondence, such as emails or letters, or if other users or third
                            parties send us correspondence about your activities or postings on the Website, we collect such
                            information into a file specific to you.
                        </p>
                    </div>
                </div>
        
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Link to third-party SDK</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>The iCeipts Platform has a link to a registered third party SDK that collects data on our behalf and
                            data is stored on a secured server to perform a credit risk assessment.
                            We ensure that our third-party service provider takes extensive security measures in order to
                            protect your personal information against loss, misuse or alteration of the data.
                            Our third-party service provider employs separation of environments and segregation of duties and
                            has strict role-based access control on a documented, authorized, need to-use basis.
        
                        </p>
                        <p>
                            The stored data is protected and stored by application-level encryption. They enforce key management
                            services to limit access to data.
                            Furthermore, our registered third party service provider provides hosting security – they use
                            industry-leading anti-virus, anti-malware, intrusion prevention systems, intrusion detection
                            systems, file integrity monitoring, and application control solutions
        
                        </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Approval of Alerts, Messages and Promotional
                            campaign</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>In addition to the General Conditions of iCeipts service a User agrees to be bound by the following
                            terms and conditions:
                        </p>
                        <p>(i) The User agrees to receive promotional, transactional and commercial communications from Vyapar
                            through calls, email, SMS or push notifications.
                        </p>
                        <p>(ii) Under certain conditions, promotional messages are transmitted to the users and that vyapar
                            shall not bear any further obligation in respect of such promotional messages.
                        </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">Cancellation/Refund Policy:</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>1. If the Refund request is reported to us through email/website within 7 days of purchase and we
                            will give you 100% money back.
                        </p>
                        <p>2. The refund request should be raised via email or website.</p>
                        <p>3. Refund policies will be applicable only for purchases equal to or more than 1 year.</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p style="font-weight:800;font-size:18px!important;">END OF TERMS OF SERVICE</p>
                        <hr>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                        <p>If you have any questions or concerns regarding this Agreement, please contact us at
                            admin@iceipts.com</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-lg-2 col-2 col-md-2"></div>
</div>































